export default function SVG_Line() {
  return (
    <div>
      <h1>SVG_Line Component</h1>
    </div>
  );
}
